<!-- メニュー一覧ページのボトムボタン -->

<template>
  <div>
    <div class="menu-footer">
      <!-- メニューが選ばれてない状態はdisabled -->
      <button
        @click="openDialogConfirmMenu"
        :disabled="!radio"
        class="bottom-button"
      >
        引き換える
      </button>
    </div>

    <!-- 選択したメニューの確認ダイアログ -->
    <DialogConfirmMenu
      ref="DialogConfirmMenu"
      :radio="radio"
      @ErrorHandlingDialog="ErrorHandlingDialog"
    />

    <!-- UseInterval内のため仕様不可ダイアログ -->
    <DialogInvalidUseInterval ref="DialogInvalidUseInterval" />

    <!-- コードが間違えている、もしくは対象外ダイアログ -->
    <DialogQRAuthBadRequest ref="DialogQRAuthBadRequest" />

    <!-- ダイアログ群 -->
  </div>
</template>

<script>
export default {
  name: "TheSheetMenuBottom",
  props: {
    radio: {
      type: String,
    },
  },

  methods: {
    // 〇〇と引き換えます。引き換えてよろしいですか？のダイアログを開く
    openDialogConfirmMenu() {
      this.$refs.DialogConfirmMenu.openDialog();
    },

    ErrorHandlingDialog(DialogInfo) {
      console.log("ErrorHandlingDialog :>> ", DialogInfo);
      switch (DialogInfo[0]) {
        case "invalid_use_interval":
          this.$refs.DialogInvalidUseInterval.openDialog();
          break;
        case "qr_auth_bad_location_request":
          this.$refs.DialogQRAuthBadRequest.openDialog();
          break;
        case "qr_auth_bad_request":
          this.$refs.DialogQRAuthBadRequest.openDialog();
          break;
        case "qr_auth_bad_otp_request":
          this.$refs.DialogQRAuthBadRequest.openDialog();
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-footer {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  background-color: #ffb206;
  padding: 15px 0;
  button {
    width: calc(100% - 30px);
    height: 46px;
    border: none;
    border-radius: 30px;
    background-color: #ffffff;
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    -webkit-box-shadow: var(--defaultBoxShadow);
    box-shadow: var(--defaultBoxShadow);
    line-height: 0;
    margin: auto;
    display: block;
  }
  button:disabled {
    background-color: #e9e9e9;
    color: #999999;
  }
}
</style>
